import { WATCH_BUTTON_SEGMENT_KEY, createPageSegmentLoadMetric } from '@confluence/browser-metrics';

export const WATCH_BUTTON_METRIC = createPageSegmentLoadMetric({
	key: WATCH_BUTTON_SEGMENT_KEY,
	ssr: Boolean(window.__SSR_RENDERED__) ? { doneAsFmp: true } : undefined,
});
